<template>
	<div class="side-menu">
		<div class="side-header pos-relative">
			<nav-link class="cursor logo pos-absolute-center" :click="() => goMenu('/community', 'COMMUNITY')">
				<img :src="require('../../assets/images/icon/logo@2x.png')" />
			</nav-link>
			<nav-link class="cursor btn-close pos-absolute-vertical" :click="closeMenu">
				<font-awesome-icon icon="times" class="color-white" />
			</nav-link>
		</div>
		<div class="side-menu-list">
			<nav-link
				class="cursor menu-title w-20 display-block"
				:class="selectMenu === 'COMMUNITY' ? 'active' : ''"
				:click="() => goMenu('/community/', 'COMMUNITY')"
			>
				<div>
					<img class="pos-absolute-vertical" :src="require('../../assets/images/icon/icon-home@2x.png')" />
					<div class="display-inline pos-relative-vertical">커뮤니티</div>
				</div>
			</nav-link>

			<nav-link
				class="cursor menu-title w-20 display-block"
				:class="selectMenu === 'BIZ' ? 'active' : ''"
				:click="() => goMenu('/mybusiness/', 'BIZ')"
			>
				<div>
					<img class="pos-absolute-vertical" :src="require('../../assets/images/icon/icon-biz@2x.png')" />
					<div class="display-inline pos-relative-vertical">내사업관리</div>
				</div>
			</nav-link>

			<nav-link
				class="cursor menu-title w-20 display-block"
				:class="selectMenu === 'FEE' ? 'active' : ''"
				:click="() => goMenu('/mybusinessfee', 'FEE')"
				v-if="!isCompany"
			>
				<div>
					<img class="pos-absolute-vertical" :src="require('../../assets/images/icon/icon-fee@2x.png')" />
					<div class="display-inline pos-relative-vertical">내사업비관리</div>
				</div>
			</nav-link>

			<nav-link
				class="cursor menu-title w-20 display-block"
				:class="selectMenu === 'MYPAGE' ? 'active' : ''"
				:click="() => goMenu('/mypage/', 'MYPAGE')"
			>
				<div>
					<img class="pos-absolute-vertical" :src="require('../../assets/images/icon/icon-doc@2x.png')" />
					<div class="display-inline pos-relative-vertical">내정보관리</div>
				</div>
			</nav-link>

			<nav-link class="cursor menu-title w-20 display-block" :class="selectMenu === 'QNA' ? 'active' : ''" :click="() => goMenu('/qna/qna', 'QNA')">
				<div>
					<img class="pos-absolute-vertical" :src="require('../../assets/images/icon/icon-qna@2x.png')" />
					<div class="display-inline pos-relative-vertical">자주하는 질문</div>
				</div>
			</nav-link>

			<!-- <a class="cursor menu-title w-20 display-block" @click="openBoard = !openBoard">
				<div>
					<img class="pos-absolute-vertical" :src="require('../../assets/images/icon/icon-home@2x.png')" />
					<div class="display-inline w-20 pos-relative-vertical">게시판</div>
					<font-awesome-icon v-if="!openBoard" icon="chevron-down" class="color-white pos-absolute-vertical pos-right-7" />
					<font-awesome-icon v-else icon="chevron-up" class="color-white pos-absolute-vertical pos-right-7" />
				</div>
			</a>
			<div class="menu-list" v-show="openBoard">
				<nav-link
					class="cursor menu-title"
					:class="selectMenu === 'HOME_NOTICE' ? 'active' : ''"
					:click="() => goMenu('/board/notice', 'HOME_NOTICE')"
				>
					<span>공지사항</span>
				</nav-link>
				<nav-link class="menu-title" :class="selectMenu === 'HOME_PDS' ? 'active' : ''" :click="() => goMenu('/board/data', 'HOME_PDS')">
					<span>자료실</span>
				</nav-link>
			</div> -->

			<!-- <a class="cursor menu-title w-20 display-block" @click="openQna = !openQna">
				<div>
					<img class="pos-absolute-vertical" :src="require('../../assets/images/icon/icon-qna@2x.png')" />
					<div class="display-inline w-20 pos-relative-vertical">Q&A</div>
					<font-awesome-icon v-if="!openQna" icon="chevron-down" class="color-white pos-absolute-vertical pos-right-7" />
					<font-awesome-icon v-else icon="chevron-up" class="color-white pos-absolute-vertical pos-right-7" />
				</div>
			</a>
			<div class="menu-list" v-show="openQna">
				<nav-link
					class="cursor menu-title"
					:class="selectMenu === 'QNA_RECEIVE' ? 'active' : ''"
					:click="() => goMenu('/qna/receive', 'QNA_RECEIVE')"
				>
					<span>쪽지함</span>
				</nav-link>
				<nav-link
					class="cursor menu-title"
					:class="selectMenu === 'QNA_CONSULT' ? 'active' : ''"
					:click="() => goMenu('/qna/consult', 'QNA_CONSULT')"
					v-if="!isCompany"
				>
					<span>1:1온라인상담</span>
				</nav-link>
				<nav-link class="menu-title" :class="selectMenu === 'QNA' ? 'active' : ''" :click="() => goMenu('/qna/qna', 'QNA')">
					<span>자주하는 질문</span>
				</nav-link>
			</div> -->
		</div>
	</div>
</template>

<script>
import eventBus from '@/plugins/event-bus';
import CONST from '@/constants';

export default {
	name: 'AppSideLeft',
	data: function() {
		return {
			CONST,
			loginMember: [
				{
					adminType: '',
					userGrdCode: '',
					userId: '',
					userPw3: '',
				},
			],
			isRegionAdmin: false,
			openBoard: false,
			openQna: false,
			selectMenu: '',
		};
	},
	created() {
		eventBus.$on(
			CONST.EVENTS.SET_SIDE_MENU,
			function(v) {
				this.selectMenu = v;
				if (v.indexOf('HOME') > -1) this.openBoard = true;
				if (v.indexOf('QNA') > -1) this.openQna = true;
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.LOGIN_COMPLETE,
			function() {
				let dt = this.$device.loadLocalData('LOGIN_USER');
				if (dt) this.loginMember = JSON.parse(dt);
				this.isRegionAdmin = this.loginMember.adminType === CONST.USER_TYPE.REP_MARKETER;
			}.bind(this),
		);
	},
	mounted: function() {
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		this.isRegionAdmin = this.loginMember.adminType === CONST.USER_TYPE.REP_MARKETER;
	},
	computed: {
		isCompany() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
	},
	methods: {
		closeMenu: function() {
			this.$device.closeSideMenu();
		},
		readyAlert: function() {
			window.alert('준비중입니다.');
		},
		goMenu: function(url, t) {
			if (t === 'ADMIN') {
				this.$session.set('userId', this.loginMember.userId);
				this.$device.pushView(CONST.API_SERVER + '/admin/login.do' + '?userId=' + this.$apiClient.getApiToken());
			} else {
				this.$device.closeSideMenu();
				this.$device.pushView(url);
				this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, t);
			}
		},
	},
};
</script>

<style scoped></style>
